import classNames from "classnames";
import React, { useState } from "react";
import iconArrowDown from "../../../assets/icons/CaretDownBlue.svg";
import iconArrowDown2 from "../../../assets/icons/CaretDown.svg";
import Check from "../../../assets/icons/check.svg";
const EnadActivityItem = ({
  list,
  knowledgeArea,
  title,
  customContainerClass,
  customContainerTitleClass,
  onSelectActivity,
  blackList,
  conditionTime,
  isGreaterOrEqual = false
}) => {
  const [showList, setShowList] = useState(false);
  const [selected, setSelected] = useState(false);
  const [selectedToDisplay, setSelectedToDisplay] = useState(null);

  const handleSelect = (title, activity) => {
    setSelected(selected?.id === activity?.id ? null : activity);
    onSelectActivity(title, activity);
  };

  const onShowList = () => {
    setShowList(!showList);
  };



  const has10MinutesOrLower = (aproxDuration) => {
    const match = aproxDuration.match(/(\d+)\s*minutos?/i);
    if (match) {
      const minutes = parseInt(match[1], 10);
      if(isGreaterOrEqual){
        return minutes >= conditionTime;
      }
      return minutes <= conditionTime;
    }
    return false;
  };

  return (
    <div
      className={classNames(
        "bg-[#F7F5F21A] bg-opacity-10  border-2 rounded-md p-4",
        customContainerClass
      )}
    >
      <div className={classNames("text-center p-4", customContainerTitleClass)}>
        {title}
      </div>
      <div
        className="flex justify-between cursor-pointer bg-[#FEFEFE40] bg-opacity-25 p-4 rounded-lg"
        onClick={() => onShowList()}
      >
        <div
          className={classNames("text-[#FEFEFE4D] bg-opacity-30", {
            "text-white": selected,
          })}
        >
          {selected?.name || "Seleccionar actividad"}
        </div>
        <div>
          <img
            className={classNames("transition-transform transform rotate-0 ", {
              "rotate-180": showList,
            })}
            src={iconArrowDown2}
            alt=""
          />
        </div>
      </div>
      <div
        className={classNames({
          "h-60 overflow-y-scroll": showList,
        })}
      >
        {showList &&
          list
            .filter((e) =>
              e.aprox_duration && has10MinutesOrLower(e.aprox_duration)
                ? e
                : false
            )
            .filter((e) =>
              knowledgeArea ? e.knowledge_area === knowledgeArea : e
            )
            .filter((e) => !blackList.includes(e.name))
            .map((activity, i) => (
              <div
                className={classNames(
                  "flex flex-col gap-2 bg-DarkBlue-500 p-4 w-full border-b border-Grey-700",
                  {
                    "bg-opacity[0%]": selected?.id === activity?.id,
                    "bg-opacity-[25%]": selected?.id !== activity?.id,
                  }
                )}
              >
                <div className="flex justify-between w-full">
                  <div className="flex items-center gap-3">
                    {selected?.id === activity?.id && (
                      <img src={Check} alt="check" />
                    )}
                    <div className="text-white">{activity?.name}</div>
                  </div>
                  <div className="flex gap-4">
                    <div
                      onClick={() => handleSelect(title, activity)}
                      className=" text-white bg-shaiaBlue rounded-md px-2 py-1 flex items-center cursor-pointer"
                    >
                      {selected && selected?.id === activity?.id
                        ? "Seleccionada"
                        : "Seleccionar"}
                    </div>
                    <div
                      className="text-shaiaBlue font-bold flex gap-1 items-center cursor-pointer"
                      onClick={() =>
                        setSelectedToDisplay(
                          selectedToDisplay?.id === activity?.id
                            ? null
                            : activity
                        )
                      }
                    >
                      <div>
                        {selectedToDisplay?.id === activity?.id
                          ? "Ver menos"
                          : "Ver más"}
                      </div>
                      <div>
                        <img
                          className={classNames(
                            "transition-transform transform rotate-0 ",
                            {
                              "rotate-180":
                                selectedToDisplay?.id === activity?.id,
                            }
                          )}
                          src={iconArrowDown}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {selectedToDisplay?.id === activity?.id && (
                  <div className="w-full text-white">
                    {activity?.description}
                  </div>
                )}
              </div>
            ))}
      </div>
    </div>
  );
};

export default EnadActivityItem;
